import { atom } from 'recoil';

export const singleProblemParametrizationState = atom({
  key: 'single-problem-parametrization',
  default: {
    noNodes: 20,
    maxCapacity: 100
  } as {
    noNodes: number;
    maxCapacity: number;
  }
});
